import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import { RendererConfigurationService } from './rendererConfigurationService'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(RendererConfigurationService)
}

export const editor = site
